import React, { useEffect } from "react";
import toast from "react-hot-toast";
import {
  changeButtonValuesAPI,
  getButtonValuesAPI,
} from "../service/AuthService";

export default function Settings() {
  const [amount, setAmount] = React.useState([
    { value: 1000, label: 1000 },
    { value: 2000, label: 2000 },
    { value: 3000, label: 3000 },
    { value: 4000, label: 4000 },
    { value: 5000, label: 5000 },
    { value: 6000, label: 6000 },
    { value: 7000, label: 7000 },
    { value: 10000, label: 10000 },
  ]);
  const [buttons, setButtons] = React.useState({});

  const getButtonValues = async () => {
    const { response } = await getButtonValuesAPI();
    setButtons(response);
  };

  useEffect(() => {
    getButtonValues();
  }, []);
  const handleSave = async () => {
    const { response, code } = await changeButtonValuesAPI(buttons);
    if (code === 200) {
      toast.success("Button Values Updated Successfully");
    }
    getButtonValues();
  };

  return (
    <app-settings-module _nghost-ng-c510745567="">
      <div _ngcontent-ng-c510745567="" className="card">
        <div
          _ngcontent-ng-c510745567=""
          className="parent-setting"
          style={{
            flex: "1 1 100%",
            boxSizing: "border-box",
            maxWidth: "100%",
            fontFamily: "Roboto,Helvetica Neue,sans-serif",
          }}
        >
          <div
            _ngcontent-ng-c510745567=""
            className="side-head"
            style={{ borderRadius: "unset" }}
          >
            <h3 _ngcontent-ng-c510745567="" className="a-setting mb-0">
              <i _ngcontent-ng-c510745567="" className="fa fa-cog fa-lg me-2" />
              <span _ngcontent-ng-c510745567="" className="setting-txt-con">
                Setting
              </span>
            </h3>
          </div>
          <div _ngcontent-ng-c510745567="" className="card-header">
            <h3 _ngcontent-ng-c510745567="" className="mb-0 theme-default bold">
              Theme{" "}
              <span _ngcontent-ng-c510745567="" className="default">
                <span _ngcontent-ng-c510745567="" className="un-bold">
                  Default
                </span>
                <i
                  _ngcontent-ng-c510745567=""
                  className="fa fa-refresh ml-2 me-2"
                />
              </span>
            </h3>
          </div>
          <div
            _ngcontent-ng-c510745567=""
            className="card-body container-fluid container-fluid-5 button-value theme-con-5"
          >
            <div _ngcontent-ng-c510745567="" className="row row5 mb-1">
              <div
                _ngcontent-ng-c510745567=""
                className="col-12 col-md-4 theme-opt-con"
              >
                <div _ngcontent-ng-c510745567="" className="theme-options">
                  <span _ngcontent-ng-c510745567="" className="circle1">
                    <span _ngcontent-ng-c510745567="" className="round bg1" />
                  </span>
                  <span _ngcontent-ng-c510745567="" className="circle1">
                    <span _ngcontent-ng-c510745567="" className="round bg2" />
                  </span>
                  <span _ngcontent-ng-c510745567="" className="circle1">
                    <span _ngcontent-ng-c510745567="" className="round bg3" />
                  </span>
                  <span _ngcontent-ng-c510745567="" className="circle1">
                    <span _ngcontent-ng-c510745567="" className="round bg4" />
                  </span>
                  <span _ngcontent-ng-c510745567="" className="circle1">
                    <span _ngcontent-ng-c510745567="" className="round bg5" />
                  </span>
                  <span _ngcontent-ng-c510745567="" className="circle1">
                    <span _ngcontent-ng-c510745567="" className="round bg6" />
                  </span>
                  <span _ngcontent-ng-c510745567="" className="circle1">
                    <span _ngcontent-ng-c510745567="" className="round bg7" />
                  </span>
                  <span _ngcontent-ng-c510745567="" className="circle1">
                    <span _ngcontent-ng-c510745567="" className="round bg8" />
                  </span>
                  <span _ngcontent-ng-c510745567="" className="circle1">
                    <span _ngcontent-ng-c510745567="" className="round bg10" />
                  </span>
                  <span _ngcontent-ng-c510745567="" className="circle1">
                    <span _ngcontent-ng-c510745567="" className="round bg9" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div _ngcontent-ng-c510745567="" className="card-header">
          <h3 _ngcontent-ng-c510745567="" className="mb-0 bold">
            Stake
          </h3>
        </div>
        <div
          _ngcontent-ng-c510745567=""
          className="card-body container-fluid container-fluid-5 button-value quick-stake-container"
        >
          <div _ngcontent-ng-c510745567="" className="row row5 mb-1 desktop-pl">
            <div _ngcontent-ng-c510745567="" className="col-3">
              <div
                _ngcontent-ng-c510745567=""
                className="button-title"
                style={{ fontSize: 14, marginLeft: "-2px" }}
              >
                <span _ngcontent-ng-c510745567="">
                  <b _ngcontent-ng-c510745567="" className="stake-amount">
                    Quick Stakes
                  </b>
                </span>
              </div>
            </div>
          </div>
          <div
            _ngcontent-ng-c510745567=""
            className="row row5 mb-1 col-md-6 col-lg-6 desktop-pl quick-stake-boxes"
          >
            {Object.keys(buttons).map(
              (item, index) =>
                item?.startsWith("buttonValue") &&
                !item?.includes("Casino") && (
                  <div
                    _ngcontent-ng-c510745567=""
                    className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                  >
                    <div
                      _ngcontent-ng-c510745567=""
                      className="form-group quick-stake-box"
                    >
                      <input
                        _ngcontent-ng-c510745567=""
                        type="text"
                        min={1}
                        onChange={(e) => {
                          setButtons((prev) => ({
                            ...prev,
                            [item]: e.target.value,
                          }));
                        }}
                        value={buttons[item]}
                        max={99999999}
                        maxLength={9}
                        className="form-control ng-untouched ng-pristine ng-valid"
                      />
                    </div>
                  </div>
                )
            )}
          </div>
          <div _ngcontent-ng-c510745567="" className="row row5 update-btn-con">
            <div
              _ngcontent-ng-c510745567=""
              onClick={() => {
                handleSave();
              }}
              className="row row5 mb-1 col-md-6 desktop-pl update-btn-container"
            >
              <button _ngcontent-ng-c510745567="" className="updatebtn">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </app-settings-module>
  );
}
